import * as React from 'react';
import FilterItemZipCodeComponent from "./filter-item-zipcode";
import FilterDropdownMileRadius from "./filter-dropdown-mile-radius";
import FilterDropdownPageSize from "./filter-dropdown-page-size";

export class FiltersPanel extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<div className="find-a-pd-filters-panel find-a-pd-filters-panel-default">
				<FilterItemZipCodeComponent />
				<FilterDropdownMileRadius  />
				<FilterDropdownPageSize />
			</div>
		)
	}
}
export default FiltersPanel;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filters-panel.tsx